import React from 'react';

const Sparkline = ({ values, width = 80, height = 28, stroke = '#D92D20' }) => {
  if (!Array.isArray(values) || values.length === 0) return null;
  if (!values.some((v) => v > 0)) return null;

  const max = Math.max(...values, 1);
  const stepX = values.length > 1 ? (width - 4) / (values.length - 1) : 0;

  const coords = values.map((v, i) => {
    const x = 2 + stepX * i;
    const y = height - 4 - (v / max) * (height - 8);
    return [x, y];
  });

  const points = coords.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const [lastX, lastY] = coords[coords.length - 1];

  return (
    <svg className="mi-spark" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      <polyline
        fill="none"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
      <circle cx={lastX} cy={lastY} r="2.5" fill={stroke} />
    </svg>
  );
};

export default Sparkline;
